import React from 'react';
import SettingsForm from '@its/components/lib/Container components/FormContainer/SettingsForm';
import translations from '../../i18n/';

export default class extends React.Component {

  render() {
    return (
      <SettingsForm
        translations={translations}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Util/Settings.js
 **/